// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".simple-keyboard[data-v-afe8db4e]{position:fixed;bottom:16px;left:380px;right:0;margin:0 auto;max-width:calc(100vw - 412px);z-index:10001;box-shadow:0 4px 12px rgba(0,0,0,.15);border-radius:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
